import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {map} from 'lodash';

// PrimeReact components
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {Dropdown} from 'primereact/dropdown';

// Catalog constants
import {ShelfTypes} from '../catalog/catalog-constants';

import PromotedFolderDialog from './promoted-folder-dialog';
import PromotedNetworkDialog from './promoted-network-dialog';

// Styles
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

const Boosts = [
    {
        label: 'Actor',
        className: 'ActorRelevance',
        shelfTypes: [ShelfTypes.ASSET],
    },
    {
        label: 'Genre',
        className: 'GenreRelevance',
        shelfTypes: [ShelfTypes.ASSET],
    },
    {
        label: 'Asset Promotion List',
        className: 'AssetPromotionList',
        shelfTypes: [ShelfTypes.ASSET],
    },
    {label: 'FVOD', className: 'FVODBoost', shelfTypes: [ShelfTypes.ASSET]},
    {
        label: 'Network Promotion List',
        className: 'NetworkPromotionList',
        shelfTypes: [ShelfTypes.NETWORK],
    },
    {
        label: 'Recommendations',
        className: 'RecommendationsBoost',
        shelfTypes: [ShelfTypes.ASSET],
    },
];

class boostListTable extends Component {
    state = {
        editMode: false,
        selectedBoost: undefined,
        folderDialogVisible: false,
        networkDialogVisible: false,
        folderPromoId: undefined,
        networkPromotionObj: undefined,
    };

    addBoost = event => {
        const {updateBoostList, shelfType} = this.props;
        const {selectedBoost} = this.state;
        const optionsInitial = this.fetchSupportedBoosts(shelfType);
        const mySelectedBoost = selectedBoost || optionsInitial[0].value || '';
        event.preventDefault();

        if (mySelectedBoost === 'AssetPromotionList') {
            this.setState({editMode: false, folderDialogVisible: true});
        } else if (mySelectedBoost === 'NetworkPromotionList') {
            this.setState({editMode: false, networkDialogVisible: true});
        } else {
            // Insert Generic Boost without a value into shelf
            updateBoostList({class: mySelectedBoost}, true);
        }
        // Update list of options
        const optionsEnd = this.fetchSupportedBoosts(shelfType).filter(k => k.value !== mySelectedBoost);
        this.setState({selectedBoost: optionsEnd.length ? optionsEnd[0].value : ''});
    };

    deleteSelected = event => {
        const {deleteSelectedBoosts} = this.props;
        const {selectedOptions} = this.state;

        event.preventDefault();

        this.setState({selectedOptions: []}, () => {
            deleteSelectedBoosts(selectedOptions);
        });
    };

    folderPromo = event => {
        const {folderPromoId} = this.state;
        event.preventDefault();
        return {
            class: 'AssetPromotionList',
            featuredFolderID: Number(folderPromoId),
        };
    };

    networkPromo = event => {
        const {networkPromotionObj} = this.state;
        event.preventDefault();
        return {
            class: 'NetworkPromotionList',
            ...networkPromotionObj,
        };
    };

    addUpdatePromo = (event, isNetwork, isUpdate = false) => {
        const {updateBoostList} = this.props;
        if (isNetwork) {
            this.setState({networkDialogVisible: false});
        } else {
            this.setState({folderDialogVisible: false});
        }
        updateBoostList(isNetwork ? this.networkPromo(event) : this.folderPromo(event), !isUpdate);
    };

    reorderBoostList = e => {
        const {reorderBoostList} = this.props;
        reorderBoostList(e);
    };

    fetchSupportedBoosts = shelfTypeIdx => {
        const {boosts} = this.props;

        const filteredBoosts =
            shelfTypeIdx === 'ASSET'
                ? Boosts.filter(sortingMethod => sortingMethod.shelfTypes.includes(ShelfTypes.ASSET))
                : Boosts.filter(sortingMethod => sortingMethod.shelfTypes.includes(ShelfTypes.NETWORK));

        return map(filteredBoosts, boostItem => ({
            label: boostItem.label,
            value: boostItem.className,
        })).filter(item => !boosts.includes(boosts.find(el => el.class === item.value)));
    };

    networksTemplate = (rowData, _column) => (
        <ul>
            {rowData.networks.map(network => (
                <li key={network}>{network}</li>
            ))}
        </ul>
    );

    actionTemplate = (rowData, _column) => {
        if (rowData.class === 'NetworkPromotionList' || rowData.class === 'AssetPromotionList') {
            return (
                <div>
                    <Button
                        className="p-button-warning"
                        icon="pi pi-pencil"
                        type="button"
                        onClick={() => {
                            rowData.class === 'NetworkPromotionList'
                                ? this.setState({
                                      editMode: true,
                                      networkPromotionObj: rowData,
                                      networkDialogVisible: true,
                                  })
                                : this.setState({
                                      editMode: true,
                                      folderPromoId: rowData.featuredFolderID,
                                      folderDialogVisible: true,
                                  });
                        }}
                    />
                </div>
            );
        }
    };

    render() {
        const {boosts, shelfType} = this.props;
        const {
            editMode,
            folderDialogVisible,
            folderPromoId,
            networkDialogVisible,
            networkPromotionObj,
            selectedBoost,
            selectedOptions,
        } = this.state;

        const assetBoostColumns = [
            {rowOrderIcon: 'e95f', rowReorder: true, style: {width: '3em'}},
            {header: 'Select All ', selectionMode: 'multiple', style: {width: '10em'}},
            {field: 'class', header: 'Active Boosts', style: {width: 320}},
            {field: 'featuredFolderID', header: 'Value'},
            {body: this.actionTemplate},
        ];

        const networkBoostColumns = [
            {rowOrderIcon: 'e95f', rowReorder: true, style: {width: '3em'}},
            {header: 'Select All ', selectionMode: 'multiple', style: {width: '7em'}},
            {field: 'class', header: 'Active Boosts', style: {width: 190, wordWrap: 'break-word'}},
            {field: 'name', header: 'Promotion Name', style: {width: 120, wordWrap: 'break-word'}},
            {
                field: 'networks',
                header: 'Included Networks',
                style: {width: 230, wordWrap: 'break-word'},
                body: this.networksTemplate,
            },
            {body: this.actionTemplate},
        ];

        let dynamicColumns;
        if (shelfType === 'ASSET') {
            dynamicColumns = assetBoostColumns.map((col, idx) => <Column key={idx} {...col} />);
        } else {
            dynamicColumns = networkBoostColumns.map((col, idx) => <Column key={idx} {...col} />);
        }

        const options = this.fetchSupportedBoosts(shelfType);

        return (
            <div>
                <DataTable
                    reorderableColumns={true}
                    reorderableRows={true}
                    selection={selectedOptions}
                    value={boosts}
                    onRowReorder={e => this.reorderBoostList(e.value)}
                    onSelectionChange={e => this.setState({selectedOptions: e.value})}
                >
                    {dynamicColumns}
                </DataTable>

                <div className="p-d-flex p-flex-row">
                    <Dropdown
                        disabled={!options.length}
                        filterPlaceholder="Select Boost"
                        id="cboBoostList"
                        options={options}
                        showClear={false}
                        style={{leftMargin: '1em', width: '200px'}}
                        value={selectedBoost || (options.length ? options[0].value : '')}
                        onChange={e => this.setState({selectedBoost: e.target.value})}
                    />

                    <Button
                        disabled={!options.length}
                        label="Add"
                        style={{marginLeft: '1em', height: 33, marginTop: 3}}
                        onClick={this.addBoost}
                    />
                    <Button
                        disabled={!selectedOptions || (selectedOptions && !selectedOptions.length)}
                        label="Delete"
                        style={{marginLeft: '1em', height: 33, marginTop: 3}}
                        onClick={this.deleteSelected}
                    />
                </div>
                <PromotedFolderDialog
                    editMode={editMode}
                    folderDialogVisible={folderDialogVisible}
                    handleCloseDialog={() => this.setState({folderDialogVisible: false})}
                    handleFolderChange={e => this.setState({folderPromoId: e.target.value})}
                    handleSubmit={e => this.addUpdatePromo(e, false, editMode)}
                    id="folderId"
                    name="folderId"
                    selectedFolder={folderPromoId}
                />

                <PromotedNetworkDialog
                    editMode={editMode}
                    handleCloseDialog={() => this.setState({networkDialogVisible: false})}
                    handleNetworkChange={e => this.setState({networkPromotionObj: e.target.value})}
                    handleSubmit={e => this.addUpdatePromo(e, true, editMode)}
                    id="networkId"
                    name="networkId"
                    networkDialogVisible={networkDialogVisible}
                    selectedNetwork={networkPromotionObj}
                />
            </div>
        );
    }
}

boostListTable.propTypes = {
    boosts: PropTypes.array.isRequired,
    deleteSelectedBoosts: PropTypes.func.isRequired,
    reorderBoostList: PropTypes.func.isRequired,
    shelfType: PropTypes.string.isRequired,
    updateBoostList: PropTypes.func.isRequired,
};

export default boostListTable;
